<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="installments"
    :indexNested="true"
    :maskFields="maskFields"
    :disablePagination="true"
    :containTopToolbar="false"
    :hasTableTitle="true"
  >

    <!-- SHOW -->
    <template slot="action1" v-if="item.statusKey == 'pending_payment' || item.statusKey == 'paid'" slot-scope="{ item }">
      <CashOutflowInstallmentEdit
        v-if="modelType == 'Purchase' || modelType == 'CashOutflow' || modelType == 'CashOutflowInstallment'"
        :entry="item"
        :readOnly="true"
      />
      <CashInflowInstallmentEdit
        v-if="modelType == 'Sale' || modelType == 'CashInflow' || modelType == 'CashInflowInstallment'"
        :entry="item"
        :readOnly="true"
      />
    </template>

    <!-- EDIT -->
    <template slot="action2" v-if="item.statusKey == 'pending_payment' && !readOnly" slot-scope="{ item }">
      <CashOutflowInstallmentEdit
        v-if="modelType == 'Purchase' || modelType == 'CashOutflow' || modelType == 'CashOutflowInstallment'"
        :entry="item"
        :editOnly="true"
        @entry-updated="updateItem(item, $event)"
      />
      <CashInflowInstallmentEdit
        v-if="modelType == 'Sale' || modelType == 'CashInflow' || modelType == 'CashInflowInstallment'"
        :entry="item"
        :editOnly="true"
        @entry-updated="updateItem(item, $event)"
      />
    </template>

    <!-- PAYMENT CONFIRMATION -->
    <template slot="action3" v-if="item.statusKey == 'pending_payment'" slot-scope="{ item }">
      <CashOutflowInstallmentPaymentConfirmation
        v-if="modelType == 'Purchase' || modelType == 'CashOutflow' || modelType == 'CashOutflowInstallment'"
        :entry="item"
        @entry-updated="updateItem(item, $event)"
      />
      <CashInflowInstallmentPaymentConfirmation
        v-if="modelType == 'Sale' || modelType == 'CashInflow' || modelType == 'CashInflowInstallment'"
        :entry="item"
        @entry-updated="updateItem(item, $event)"
      />
    </template>

    <!-- PAYMENT CANCELLATION -->
    <template slot="action4" v-if="item.statusKey == 'paid'" slot-scope="{ item }">
      <CashOutflowInstallmentPaymentCancellation
        v-if="modelType == 'Purchase' || modelType == 'CashOutflow' || modelType == 'CashOutflowInstallment'"
        :entry="item"
        @entry-destroyed="updateItem(item, $event)"
      />
      <CashInflowInstallmentPaymentCancellation
        v-if="modelType == 'Sale' || modelType == 'CashInflow' || modelType == 'CashInflowInstallment'"
        :entry="item"
        @entry-destroyed="updateItem(item, $event)"
      />
    </template>


    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td><strong class="title">Total:</strong></td>
        <td class="text-xs-left title"><strong>{{ this.installmentsTotal | formatCurrency }}</strong></td>
        <td></td>
      </tr>

       <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.installmentsTotal | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
// import CashOutflowInstallmentEdit from "@models/installments/cash_outflow_installments/edit.vue"
// import CashInflowInstallmentEdit from "@models/installments/cash_inflow_installments/edit.vue"
// import CashOutflowInstallmentPaymentConfirmation from "@models/installments/cash_outflow_installments/payment_confirmation.vue"
// import CashInflowInstallmentPaymentConfirmation from "@models/installments/cash_inflow_installments/payment_confirmation.vue"
// import CashOutflowInstallmentPaymentCancellation from "@models/installments/cash_outflow_installments/payment_cancellation.vue"
// import CashInflowInstallmentPaymentCancellation from "@models/installments/cash_inflow_installments/payment_cancellation.vue"

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      installmentHrefType: null,
      indexKey: 1,
      tableHeaders: [
        { text: "#", align: "left", sortable: true, value: "code" },
        { text: "R$", align: "left", sortable: true, value: "value" },
        { text: "Conta Bancária", align: "left", sortable: true, value: "bankAccount.name" },
        { text: "Data", align: "left", sortable: true, value: "dueDate" },
        { text: "R$ Pago", align: "left", sortable: true, value: "totalPaidAmount" },
        { text: "Pagamento", align: "left", sortable: true, value: "paymentDate" },
        { text: "Status", align: "left", sortable: true, value: "status" },
        { text: "Ações", value: "action", sortable: false },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true},
      ],
      maskFields: [
        { field: 'value', mask: 'currency' },
        { field: 'dueDate', mask: 'date' },
        { field: 'totalPaidAmount', mask: 'currency' },
        { field: 'paymentDate', mask: 'date' },
        { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex, 
    // CashOutflowInstallmentEdit: CashOutflowInstallmentEdit,
    // CashInflowInstallmentEdit: CashInflowInstallmentEdit,
    // CashOutflowInstallmentPaymentConfirmation: CashOutflowInstallmentPaymentConfirmation,
    // CashInflowInstallmentPaymentConfirmation: CashInflowInstallmentPaymentConfirmation,
    // CashOutflowInstallmentPaymentCancellation: CashOutflowInstallmentPaymentCancellation,
    // CashInflowInstallmentPaymentCancellation: CashInflowInstallmentPaymentCancellation,
    // CashOutflowInstallmentEdit: () => import('../installments/cash_outflow_installments/edit.vue'), 
    // CashInflowInstallmentEdit: () => import('../installments/cash_inflow_installments/edit.vue'), 
    // CashOutflowInstallmentPaymentConfirmation: () => import('../installments/cash_outflow_installments/payment_confirmation.vue'),
    // CashInflowInstallmentPaymentConfirmation: () => import('../installments/cash_inflow_installments/payment_confirmation.vue'), 
    // CashOutflowInstallmentPaymentCancellation: () => import('../installments/cash_outflow_installments/payment_cancellation.vue'), 
    // CashInflowInstallmentPaymentCancellation: () => import('../installments/cash_inflow_installments/payment_cancellation.vue'),
  },
  beforeCreate: function () {
    this.$options.components.CashOutflowInstallmentEdit = require('../installments/cash_outflow_installments/edit.vue').default
    this.$options.components.CashInflowInstallmentEdit = require('../installments/cash_inflow_installments/edit.vue').default 
    this.$options.components.CashOutflowInstallmentPaymentConfirmation = require('../installments/cash_outflow_installments/payment_confirmation.vue').default
    this.$options.components.CashInflowInstallmentPaymentConfirmation = require('../installments/cash_inflow_installments/payment_confirmation.vue').default
    this.$options.components.CashOutflowInstallmentPaymentCancellation = require('../installments/cash_outflow_installments/payment_cancellation.vue').default
    this.$options.components.CashInflowInstallmentPaymentCancellation = require('../installments/cash_inflow_installments/payment_cancellation.vue').default
  },
  props: {
    installments: {
      type: Array,
      default: []
    },
    installmentsTotal: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    modelType: {
      type: String,
    },
    modelNameSingular: {
      type: String,
      default: "Parcela"
    },
    modelNamePlural: {
      type: String,
      default: "Parcelas"
    },
  },
  created() {
    if (this.modelType == "Sale" || this.modelType == "CashInflow") {
      this.installmentHrefType = "cash_inflow_installment";
    } else if (this.modelType == "Purchase" || this.modelType == "CashOutflow") {
      this.installmentHrefType = "cash_outflow_installment";
    }
  },
  methods: {
    updateItem: function(item, newItem) {
      // console.log("CHAMOU O UPDATE")
      // console.log(item, newItem);
      // console.log(this.installments);

      // let installment = this.installments.find(obj => obj.id == item.id);
      // Object.assign(installment, newItem);

      this.$emit('installment-update', newItem);
    }
  }
};
</script>

<style scoped></style>
